import * as React from 'react'
import { RouterState, RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'
import { LoadingSpinner } from '../components/LoadingSpinner'
import * as Auth from '../services/auth/auth'
import { Api } from '../services/api/api'

import { ClientInfo } from '../types'
import { ROUTES, DEFAULT_ROUTE } from '../constants/routes'

import { ActionType, Actions } from '../actions/signIn'
import { StoreState } from '../reducers'

import '../styles/App.scss'
import '../styles/StartingPage.scss'

interface AuthHandlerProps {
	isSigned: boolean
	onUserSigned: (userData: ClientInfo) => ActionType
	routePush: (location: string) => RouterAction
}

interface AuthHandlerStates {
	isTokenReceived: boolean
}

export class AuthHandler extends React.Component<AuthHandlerProps, AuthHandlerStates> {
	constructor(props: any) {
		super(props)
		this.state = {
			isTokenReceived: false
		}
	}

	componentDidMount() {
		if (!this.props.isSigned) {
			Auth.getCurrentToken()
				.then((token: string) => {
					Api.getClientInfo()
						.then((userData: ClientInfo) => {
							this.props.onUserSigned(userData)
							this.setTokenReceived()
						})
						.catch(error => {
							console.log(error)
							this.setTokenReceived()
						})
				})
				.catch(error => {
					console.log(error)
					this.setTokenReceived()
					this.props.routePush(ROUTES.SIGN_IN)
				})
		} else {
			this.setTokenReceived()
		}
	}

	setTokenReceived = () => {
		this.setState({
			isTokenReceived: true
		})
	}

	render() {
		return (
			<div className="App starting-page">
				<LoadingSpinner show={!this.state.isTokenReceived} />
				{this.state.isTokenReceived && this.props.children}
			</div>
		)
	}
}

function mapStateToProps(state: StoreState) {
	return {
		routing: state.routing,
		isSigned: state.auth.isSigned
	}
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | ActionType>) {
	return {
		routePush: (location: string) => dispatch(routerActions.push(location)),
		onUserSigned: (userData: ClientInfo) => dispatch(Actions.authorize(userData))
	}
}

export const AuthHandlerContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(AuthHandler)



// WEBPACK FOOTER //
// ./src/containers/AuthHandler.tsx